<template>
  <googleMap :class="'google-map-partners-container'" v-if="smartPoints && smartPoints.length > 0">
    <div slot="header" class="google-map-partners-header">
      <h1 class="google-map-partners-header-text">{{ t('google.maps.partners.head.title') }}</h1>
    </div>
    <div slot="search" class="google-map-partners-search">
      <div class="google-map-partners-search-container">
        <div class="google-map-partners-search-container-text">
          <span class="google-map-partners-search-container-text-num">{{ smartPoints.length
            }}</span>
          <span class="google-map-partners-search-container-text-title">
            {{ t('google.maps.partners.head.title') }}
          </span>
        </div>
        <input type="text"
               class="google-map-partners-search-container-input"
               placeholder="Search"
               aria-label="Search"
               v-model="searchInput"
               @keydown.enter.prevent="searchSmartPoints(searchInput)"
        />
      </div>
    </div>
    <div slot="listing" class="google-map-partners-infos-item-container">
      <div
        v-for="smartPoint in cachedFilteredSearchedClosestSmartPoints"
        :key="smartPoint.id"
        class="google-map-partners-infos-item"
        :class="getSmartPointChecked(smartPoint) ? 'checked' : ''"
      >
        <div class="google-map-partners-infos-item-card">
          <div class="google-map-partners-infos-item-card-body" @click="setSmartPointChecked(smartPoint)">
            <ul class="google-map-partners-infos-item-card-body-infos">
              <li class="google-map-partners-infos-item-card-body-info" v-html="smartPoint.note"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div slot="map" class="google-map-partners-map-container">
      <div v-if="getGoogleMapLoading" class="lds-ripple-container">
        <div class="lds-ripple"><div></div><div></div></div>
      </div>
      <section :style="!getGoogleMapLoading ? '' : 'opacity: 0'" class="google-map-partners-map">
        <div id="map" style="height: 100%; width: 100%"></div>
      </section>
      <div class="google-map-partners-reset" @click="resetMap()">
        <span class="google-map-partners-reset-text">
          {{ t('google.maps.partners.map.reset') }}
        </span>
      </div>
    </div>
  </googleMap>
</template>

<script>

import googleMap from '../googleMap'
import googleMapMixin from '../mixins/googleMapMixin'

export default {
  name: 'googleMapPartners',
  mixins: [googleMapMixin],
  components: {
    googleMap
  }
}
</script>

<style lang="scss" scoped>
.google-map-partners {
  &-container {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-template-rows: auto auto auto;
    padding: 20px 15px;
  }
  &-header {
    grid-row: 1;
    margin-bottom: 15px;
    width: 100%;
    grid-column: 1/span 2;
    &-text {
      padding: 0;
      font-size: 25px;
      margin-bottom: 0;
      font-weight: 700;
    }
  }
  &-search {
    grid-column: 1 / span 2;
    grid-row: 2;
    margin-bottom: 30px;
    &-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      @media screen and (max-width: 767px) {
        grid-template-columns: auto;
        gap: 1rem;
      }
      &-text {
        background: #000303;
        text-align: center;
        &-num, &-title {
          font-size: 25px;
          font-weight: 700;
          color: white;
        }
      }
      &-input {
        transition: all .3s ease-in-out;
        padding-left: 10px;
        padding-right: 10px;
        display: flex;
        width: 100%;
        height: 100%;
        border: 1px solid #eaeaea;
        border-bottom-right-radius: 5px;
        border-top-right-radius: 5px;
        font-size: 18px;
        @media screen and (max-width: 767px) {
          font-size: 18px;
          border-radius: 5px;
          height: 48px;
        }
      }
    }
  }
  &-map {
    height: 100%;
    &-container {
      position: relative;
      height: 100%;
      max-height: 66.6667vh;
      grid-row: 3;
      @media screen and (max-width: 767px) {
        height: 400px;
        grid-column: 1/span 2;
      }
    }
  }
  &-infos {
    &-item {
      transition: all .2s ease;
      &:nth-child(odd) {
        background: #eaeaea;
      }
      &:hover {
        cursor: pointer;
        background: #000303;
        .google-map-partners-infos-item-card-body-info {
          color: white;
        }
      }
      &-container {
        position: relative;
        height: 100%;
        max-height: 66.6667vh;
        overflow-x: auto;
        overflow-y: scroll;
        box-sizing: border-box;
        width: calc(100% + 18px);
        grid-row: 3;
        @media screen and (max-width: 767px) {
          grid-row: 4;
          grid-column: 1/span 2;
        }
      }
      &-card {
        &-body {
          &-infos {
            list-style: none;
            padding: 0;
            margin: 0;
          }
          &-info {
            display: block;
            width: 100%;
            padding: 5px 25px 5px 10px;
            color: #222;
            font-size: 14px;
            position: relative;
            margin: 0;
          }
        }
      }
    }
  }
  &-reset {
    position: absolute;
    top: 1rem;
    right: 1rem;
    padding-left: 10px;
    padding-right: 10px;
    background: rgb(180 180 180 / 90%);
    color: white;
    border-radius: 5px;
    transition: all 0.3s ease-in-out;
    &:hover {
      cursor: pointer;
      transform: scale(1.05);
    }
  }
}
.lds-ripple-container {
  position: relative;
  display: grid;
  justify-items: center;
  align-items: center;
  justify-content: center;
  align-content: center;
  width: 100%;
  height: 100%;
  background: rgba(206, 206, 206, 0.25);
  border-radius: 5px;
}
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #7de17d;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0;
    left: 0;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}
</style>
